import { render, staticRenderFns } from "./NotificationTemplatesTable.vue?vue&type=template&id=7e3f1151&scoped=true"
import script from "./NotificationTemplatesTable.vue?vue&type=script&lang=js"
export * from "./NotificationTemplatesTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplatesTable.vue?vue&type=style&index=0&id=7e3f1151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3f1151",
  null
  
)

export default component.exports